/**
 * Shared business constants - status labels, badge metadata, role labels.
 */
import {
    AlertTriangle,
    BadgeCheck,
    Brain,
    Crown,
    Flame,
    Star,
    Target,
    TrendingDown,
    Zap,
} from "lucide-react";

export const ROLES = {
    pre_recruteur: { label: "Pré-recruteur", short: "Pré-rec" },
    referent: { label: "Référent terrain", short: "Référent" },
    admin: { label: "Back office RH", short: "Admin" },
    coordinateur: { label: "Coordinateur RH", short: "Coordinateur" },
};

export const STATUS_META = {
    new: { label: "À appeler", color: "bg-amber-50 text-amber-700 border-amber-200" },
    prerec_assigned: { label: "À appeler", color: "bg-amber-50 text-amber-700 border-amber-200" },
    prerec_done: { label: "Pré-rec terminé", color: "bg-violet-50 text-violet-700 border-violet-200" },
    immersion_scheduled: { label: "Immersion prévue", color: "bg-cyan-50 text-cyan-700 border-cyan-200" },
    immersion_done: { label: "Immersion faite", color: "bg-teal-50 text-teal-700 border-teal-200" },
    awaiting_validation: { label: "Validation attente", color: "bg-orange-50 text-orange-700 border-orange-200" },
    validated: { label: "Validé", color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
    onboarding: { label: "Onboarding", color: "bg-lime-50 text-lime-700 border-lime-200" },
    hired: { label: "Recruté", color: "bg-green-100 text-green-800 border-green-300" },
    rejected: { label: "Refusé", color: "bg-red-50 text-red-700 border-red-200" },
};

export const BADGE_META = {
    pepite: { label: "Pépite", icon: Flame, color: "from-[#FCDB53]/30 to-[#EE722E]/30 text-[#EE722E] border-[#FCDB53]/50" },
    urgent: { label: "Appel urgent", icon: Zap, color: "from-[#DC2626]/15 to-[#DC2626]/5 text-[#DC2626] border-[#DC2626]/30" },
    communicant: { label: "Communicant", icon: Brain, color: "from-blue-200/30 to-blue-100/30 text-blue-700 border-blue-200" },
    compatible_terrain: { label: "Compatible terrain", icon: Target, color: "from-emerald-200/30 to-emerald-100/30 text-emerald-700 border-emerald-200" },
    potentiel_manager: { label: "Potentiel manager", icon: Crown, color: "from-violet-200/30 to-violet-100/30 text-violet-700 border-violet-200" },
    risque_turnover: { label: "Risque turnover", icon: AlertTriangle, color: "from-red-100 to-red-50 text-red-700 border-red-200" },
    a_challenger: { label: "À challenger", icon: Star, color: "from-amber-200/30 to-amber-100/30 text-amber-800 border-amber-200" },
    faible_priorite: { label: "Faible priorité", icon: TrendingDown, color: "from-slate-200/30 to-slate-100/30 text-slate-600 border-slate-200" },
    excellence: { label: "Excellence", icon: BadgeCheck, color: "from-emerald-200/30 to-emerald-100/30 text-emerald-700 border-emerald-200" },
};

export const PROFILE_META = {
    relationnel_communicant: "Relationnel / Communicant",
    persuasif_commercial: "Persuasif / Commercial",
    resilient_terrain: "Résilient / Terrain",
    stable_fiable: "Stable / Fiable",
    leader_potentiel: "Leader potentiel",
    junior_a_former: "Junior à former",
    a_risque_instable: "À risque / Instable",
};

export const RISK_META = {
    low: { label: "Faible", color: "text-emerald-600", bg: "bg-emerald-50" },
    medium: { label: "Moyen", color: "text-amber-600", bg: "bg-amber-50" },
    high: { label: "Élevé", color: "text-red-600", bg: "bg-red-50" },
};

export const SCORE_COLORS = (score) => {
    if (score >= 85) return { ring: "#16A34A", text: "text-emerald-600" };
    if (score >= 70) return { ring: "#EE722E", text: "text-[#EE722E]" };
    if (score >= 55) return { ring: "#FCDB53", text: "text-amber-600" };
    return { ring: "#DC2626", text: "text-red-600" };
};

export const SUB_SCORE_LABELS = {
    communication: "Communication",
    energie: "Énergie",
    persuasion: "Persuasion",
    resilience: "Résilience",
    stabilite: "Stabilité",
    mobilite: "Mobilité",
    compatibilite_shariti: "Compatibilité Shariti",
    potentiel_long_terme: "Potentiel long terme",
    risque_attrition: "Risque attrition",
};

export const PROFILE_DOMINANT_LABELS = {
    relationnel_communicant: "Relationnel communicant",
    persuasif_commercial: "Persuasif commercial",
    resilient_terrain: "Résilient terrain",
    stable_fiable: "Stable et fiable",
    leader_potentiel: "Leader potentiel",
    junior_a_former: "Junior à former",
    a_risque_instable: "À risque / instable",
};
